import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { TextField } from 'fields';
import { useField } from 'formik';

import type { IBulkQuantity } from './types';

export default function BulkQuantity({ disabled }: IBulkQuantity) {
  const { t } = useTranslation('CreateOrder');

  const [{ value = {} }] = useField('productData');

  const { packageIsSolid = false, packageDescription = '' } = value || {};

  const step = useMemo(() => {
    if (!packageIsSolid) return 1;
    const packageSize = Number(packageDescription.replace(/\D/g, '') || 0);

    return packageSize ? packageSize / 1000 : 1;
  }, [packageDescription, packageIsSolid]);

  return (
    <TextField
      required
      type="number"
      inputProps={{ step }}
      disabled={disabled}
      name="packagedItemQty"
      label={t('ProductForm.labels.bulkQuantity')}
      placeholder={t('ProductForm.placeholders.bulkQuantity')}
    />
  );
}
